const formObserver = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      const addedNode = mutation.addedNodes[0];
      if (typeof addedNode?.id === "string" && addedNode.id.includes("app-embed")) {
        observeInitForm(addedNode);
        return;
      }
    }
  });
});

formObserver.observe(document.body, { childList: true, subtree: true });

function observeInitForm(form) {
  const formContentContainer = form.shadowRoot.querySelector("div");
  const formElement = formContentContainer.querySelector("form");
  const labels = formContentContainer.querySelectorAll("label");
  changeLabelToRtl(labels);
  formElement.addEventListener("submit", (event) => {
    event.preventDefault();
    updateOutputs(formElement);
  });
}

function changeLabelToRtl(labels) {
  labels.forEach((label) => {
    label.style.right = "15px";
    label.style.left = "unset";
    label.style.transformOrigin = "right";
  });
} 

// Function to update output elements
function updateOutputs(formData) {
  // Select all output elements with the specified class
  const outputElements = formData.querySelectorAll("output");
  if (!outputElements) {
    return;
  }
  // Iterate through the form data and update corresponding output elements
  outputElements.forEach((errorElement) => {
    errorElement.innerText = "שדה חובה"
  });
}
